import {
  type ScreeningSurveySubmitBody,
  ScreeningSurveySubmitBodySchema,
  type ScreeningSurveySubmitResponse,
  ScreeningSurveySubmitResponseSchema,
} from "@clipboard-health/contract-home-health-api";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type z } from "zod";

import { IN_HOME_APP_EVENTS } from "../../lib/events";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";

function getSubmitUrl(workerId: string) {
  return `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workers/${workerId}/screening-surveys`;
}

export function useSubmitScreeningSurvey(
  workerId: string,
  options: UseMutationOptions<ScreeningSurveySubmitResponse, unknown, ScreeningSurveyFormData> = {}
) {
  return useMutation({
    mutationFn: async (formData: ScreeningSurveyFormData) => {
      const response = await post({
        url: getSubmitUrl(workerId),
        data: {
          data: {
            type: "screening-survey" as const,
            attributes: formData,
          },
        },
        // ZodEffects transforms (for requiredEnumWithFallback and dateTimeSchema) require z.ZodType<T> assertions
        requestSchema: ScreeningSurveySubmitBodySchema as z.ZodType<ScreeningSurveySubmitBody>,
        responseSchema:
          ScreeningSurveySubmitResponseSchema as z.ZodType<ScreeningSurveySubmitResponse>,
      });
      return response.data;
    },
    meta: {
      userErrorMessage: "Failed to submit survey. Please try again.",
      logErrorMessage: IN_HOME_APP_EVENTS.SCREENING_SURVEY_SUBMISSION_FAILED,
    },
    ...options,
  });
}
